import { Transition } from 'semantic-ui-react';

export default Transition;
